import { TaskVisibility } from "../../TaskView/Cells/TaskVisibility";
import { toReadOnlyTaskCell } from "./taskRowCells";

/** The Visibility column (organizations only): which clients can see the task. */
export const TaskVisibilityCell = toReadOnlyTaskCell(TaskVisibility);
